import ddt from '@wix/da-ddt';
class RefreshGuard {
    guard(renderEvent) {
        const refreshWindow = window['googletag'].pubads().getTargeting('refreshwindow');
        const refreshCap = window['googletag'].pubads().getTargeting('refreshcap');
        if (Array.isArray(refreshWindow) && refreshWindow.length === 1 && Array.isArray(refreshCap) && refreshCap.length === 1) {
            const slotElementId = renderEvent.slot.getSlotElementId();
            const cap = parseInt(refreshCap[0]);
            const window1 = parseInt(refreshWindow[0]);
            var _this_refreshTimers_slotElementId;
            const last = (_this_refreshTimers_slotElementId = this.refreshTimers[slotElementId]) !== null && _this_refreshTimers_slotElementId !== void 0 ? _this_refreshTimers_slotElementId : 0;
            const now = performance.now();
            this.refreshTimers[slotElementId] = now;
            const diff = now - last;
            if (last === 0) {
                return false; // dont count first render
            }
            // Refreshed too soon
            if (diff < window1) {
                var _this_refreshCounters_slotElementId;
                this.refreshCounters[slotElementId] = ((_this_refreshCounters_slotElementId = this.refreshCounters[slotElementId]) !== null && _this_refreshCounters_slotElementId !== void 0 ? _this_refreshCounters_slotElementId : 0) + 1;
            } else {
                var _this_refreshCounters_slotElementId1;
                // decrement the counter when we get a render outside range
                // as we are only interested in sequential over refreshes
                this.refreshCounters[slotElementId] = Math.max(0, ((_this_refreshCounters_slotElementId1 = this.refreshCounters[slotElementId]) !== null && _this_refreshCounters_slotElementId1 !== void 0 ? _this_refreshCounters_slotElementId1 : 0) - 1);
            }
            if (this.refreshCounters[slotElementId] > cap) {
                ddt.alert('ads', 'Removed ads for unit that refreshed early', [
                    'ads'
                ], {
                    cap,
                    slotElementId,
                    diff
                });
                return true;
            }
        }
        return false;
    }
    clearFor(slot) {
        this.refreshCounters[slot] = 0;
        this.refreshTimers[slot] = 0;
    }
    constructor(){
        this.refreshTimers = {};
        this.refreshCounters = {};
    }
}
export default RefreshGuard;
